export const uploadMap = {
  index: {
    title: '업로드',
    path: '/upload',
    display: true,
  },
  'task-list': {
    title: '업로드',
    path: '/upload/task-list',
    display: true,
  },
  task: {
    title: '작업',
    path: '/upload/:shopID/task-list/:taskID',
    display: false,
  },
};
